module.exports = __webpack_public_path__ + "img/about-career-01.7fb59021.webp";